import { TRANSLATABLE_PAYMENT_STATES } from "../enum/online_purchase";

export var online_purchase_table = {
  data() {
    return {
      headers: [
        {
          text: this.$t("thead.time"),
          value: "created_at",
          renderer: "datetime",
          search_type: "text"
        },
        {
          text: this.$t("thead.product"),
          value: "product_name",
          search_type: "text"
        },
        {
          text: this.$t("thead.amount"),
          value: "amount",
          renderer: "currency-cents",
          search_type: "text"
        },
        {
          text: this.$t("thead.state"),
          value: "external_payment_state",
          renderer: "payment_state",
          search_type: "text",
          multiple: true,
          choices: TRANSLATABLE_PAYMENT_STATES
        },
        {
          text: this.$t("thead.license_plate"),
          value: "customer_license_plate",
          search_type: "text"
        }
      ]
    };
  }
};

export var online_purchase_view = {
  data() {
    return {
      webshopPayment: null
    };
  },
  async mounted() {
    await this.$store
      .dispatch("webshop/getPaymentById", this.$route.params.id)
      .then(response => {
        this.webshopPayment = response.data;
      })
      .finally(() => {
        let QRCode = require("qrcode");
        let canvas = document.getElementById("delayed_delivery_identifier");
        QRCode.toCanvas(
          canvas,
          this.webshopPayment.delayed_delivery_identifier,
          { width: 250 },
          function() {}
        );
      });
  }
};
